<template>
    <div id="addMaterial" class="app-inner">
        <div class="public-btn-small flex align-cen posta">
            <div class="public-btn-small-plan"  style="margin-left:0" @click="$util.reback('/materialLibrary')">
            返回
            </div>
           <el-button type="primary"  :loading="loading" class="public-btn-small-primary public-btn-small-load" style="margin-left:16px"
           @click="openSub('ruleForm')"
            >
             {{$route.query.id ? '替换' : '保存'}}
           </el-button>
            </div>
         <div class="edit-from">
             <el-form ref="ruleForm" :model="form" label-width="150px" :rules="rules" class="flex">
                 <div class="public-tit flex align-cen">
            <div class="public-tit-list">
                <i class="icon-al-database-fill"></i>  基本信息
            </div>
        </div>
             <el-form-item label="素材名称：">
                    <el-input v-model="form.name" placeholder="请输入素材名称【1-50】" clearable></el-input>
             </el-form-item>
                <el-form-item label="素材分类：" prop="classifyId">
                 <el-select
                        v-model="form.classifyId"
                        clearable
                        placeholder="请选择素材分类"
                    >
                        <el-option
                        v-for="item in itemList"
                          :key="item.id"
                        :label="item.name"
                        :value="item.id"
                        >
            </el-option>
          </el-select>
         </el-form-item>
             </el-form>
         </div>
           <!-- 视频压缩进度弹窗 -->
           <el-dialog
             :visible.sync="compressDialogVisible"
             title="正在压缩文件"
             width="400px"
             :close-on-click-modal="false"
             :close-on-press-escape="false"
             :show-close="false"
             center
           >
             <div style="text-align:center;padding:10px 0 20px">
               <p style="margin-bottom:16px;color:#666">
                 {{ compressLabel }}，请勿关闭页面...
               </p>
               <el-progress :percentage="compressProgress" :stroke-width="12" />
               <p style="margin-top:12px;font-size:12px;color:#aaa">
                 视频压缩在浏览器内运行，文件越大耗时越长，请耐心等待
               </p>
             </div>
           </el-dialog>

           <div class="importTopic">
            <el-upload
            accept="" drag
            :limit="1"
          :action="uploadUrl"
             :data="dataObj"
              :headers="headers"
              :before-upload="onBeforeUploadVideo"
              :http-request="customHttpRequest"
             :on-success="handleSuccess"
              ref="upload"
              >
                <i class="icon-al-file-fill"></i>
                <div class="el-upload__text">
                   <template v-if="compressing">
                     <i class="el-icon-loading"></i> 正在压缩文件，请稍候...
                   </template>
                   <template v-else>
                     请将文件拖拽到此区域上传，或<em>选择文件上传</em>
                   </template>
                </div>
               <el-button size="small" type="primary" :disabled="compressing">
                 {{ compressing ? '压缩中...' : '选择文件' }}
               </el-button>
            </el-upload>
            <div class="tips-text">
                <div class="title">上传说明</div>
                <p style="margin-top:17px">
                 视频格式支持:3gp、av、fiv、mp4、mpg、asf、wmv、mkv、mov、dat 等格式，文件大小不能超过2G。
                </p>
                <p>音频格式支持:mp3，m4a，wma，wav格式，文件大小不超过200M。</p>
                <p>文档格式支持:doc，docx，wps，ppt,pptx，pdf,himl，txt，xls，xsx格式，文件大小不超过300M。</p>
            </div>
        </div>
    </div>
</template>
<script>
import {materialAllClassify,editMaterial,deletMaterial,policy} from "@/api/index/index"  //素材库分类、新增/修改素材、素材详情
import debounce from '../../../utils/debounce.js' //防抖
import { compressFile } from '../../../utils/compress.js' //文件压缩
export default {
    data () {
        return {
              uploadUrl:'',
            dataObj:{
                policy:'',
                signature:'',
                ossaccessKeyId:'',
                key:'',
                dir:'',
                host:'',
                callback:''
            },
            loading:false,
            compressing:false,          // 压缩中状态（上传区 loading 用）
            compressedFile:null,        // 压缩后的文件（供 http-request 使用）
            compressDialogVisible:false, // 压缩进度弹窗
            compressProgress:0,          // 压缩进度 0~100
            compressLabel:'正在压缩',     // 弹窗提示文字
            itemList:[],
            uploadParms:{},
            form:{
                classifyId:'',
                name:'',
            },
            rules:{
              classifyId: [{ required: true, message: '请选择素材分类', trigger: 'change' }],
            }
        }
    },
    created() {
        this.getLibClass()
        this.getCertDetail()
            let token = this.$locaStorage.setAge().get('token')
        if(token){
            this.headers = {
                'Authorization': token
            }
        }
    },
    methods: {
        // el-文件上传组件（压缩 + 获取上传凭证）
        onBeforeUploadVideo (file) {
            const isVideo = file.type.startsWith('video/')
            const MB = 1024 * 1024
            const sizeMB = (file.size / MB).toFixed(0)

            return new Promise(async (resolve, reject) => {
                try {
                    if (isVideo && file.size > 300 * MB) {
                        // 视频 > 300MB：弹确认提示，告知压缩较慢
                        const confirmed = await this.$confirm(
                            `当前视频约 ${sizeMB}MB，浏览器压缩较慢（预计需要数分钟），建议提前用本地工具压缩后再上传。\n\n是否继续在浏览器内压缩？`,
                            '文件较大',
                            {
                                confirmButtonText: '继续压缩',
                                cancelButtonText: '直接上传（不压缩）',
                                type: 'warning',
                                distinguishCancelAndClose: true
                            }
                        ).then(() => 'compress').catch(action => action === 'cancel' ? 'skip' : 'abort')

                        if (confirmed === 'abort') { reject(false); return }
                        if (confirmed === 'skip') {
                            // 直接上传，不压缩
                            this.compressedFile = file
                            this.compressing = false
                            const res = await policy()
                            if (res.code == 0) {
                                if (res.data) {
                                    this.uploadUrl = res.data.host
                                    this.dataObj = {
                                        policy: res.data.policy,
                                        signature: res.data.signature,
                                        ossaccessKeyId: res.data.accessId,
                                        key: res.data.dir + file.uid + file.name,
                                        dir: res.data.dir,
                                        host: res.data.host,
                                        callback: res.data.callback
                                    }
                                } else {
                                    this.uploadUrl = this.$config.baseUrl + '/admin/sys-file/upload'
                                }
                                resolve(true)
                            } else {
                                this.$util.Notifi(res.msg, 'error', 'fa-exclamation-circle')
                                reject(false)
                            }
                            return
                        }

                        // 用户选择压缩
                        this.compressing = true
                        this.compressProgress = 0
                        this.compressLabel = '正在压缩视频'
                        this.compressDialogVisible = true
                        this.compressedFile = await compressFile(file, {
                            crf: 30,
                            preset: 'ultrafast',
                            onProgress: (p) => { this.compressProgress = p }
                        })
                        this.compressDialogVisible = false
                        this.compressing = false

                    } else if (!isVideo) {
                        // 图片：轻量压缩，不需要弹窗
                        this.compressing = true
                        this.compressLabel = '正在压缩图片'
                        this.compressedFile = await compressFile(file, { maxWidth: 1920, maxHeight: 1080, quality: 0.8 })
                        this.compressing = false
                    } else {
                        // 视频 <= 300MB，不压缩
                        this.compressedFile = file
                    }

                    // 压缩成功提示
                    if (this.compressedFile !== file) {
                        const before = (file.size / 1024 / 1024).toFixed(2)
                        const after = (this.compressedFile.size / 1024 / 1024).toFixed(2)
                        this.$message.success(`压缩完成：${before}MB → ${after}MB`)
                    }

                    // 获取 OSS 上传凭证
                    const res = await policy()
                    if (res.code == 0) {
                        if (res.data) {
                            this.uploadUrl = res.data.host
                            this.dataObj = {
                                policy: res.data.policy,
                                signature: res.data.signature,
                                ossaccessKeyId: res.data.accessId,
                                key: res.data.dir + file.uid + this.compressedFile.name,
                                dir: res.data.dir,
                                host: res.data.host,
                                callback: res.data.callback
                            }
                        } else {
                            this.uploadUrl = this.$config.baseUrl + '/admin/sys-file/upload'
                        }
                        resolve(true)
                    } else {
                        this.$util.Notifi(res.msg, 'error', 'fa-exclamation-circle')
                        reject(false)
                    }
                } catch (err) {
                    this.compressing = false
                    this.compressDialogVisible = false
                    console.error('[上传] 压缩失败：', err)
                    this.$message.error('文件压缩失败：' + (err.message || err))
                    reject(false)
                }
            })
        },
        // 自定义上传请求（使用压缩后的文件）
        customHttpRequest (options) {
            const file = this.compressedFile || options.file
            const formData = new FormData()

            // 附加 OSS 表单字段
            if (options.data) {
                Object.keys(options.data).forEach(key => {
                    formData.append(key, options.data[key])
                })
            }
            formData.append('file', file, file.name)

            const xhr = new XMLHttpRequest()
            xhr.open('POST', options.action, true)

            // 附加请求头
            if (options.headers) {
                Object.keys(options.headers).forEach(key => {
                    xhr.setRequestHeader(key, options.headers[key])
                })
            }

            xhr.upload.onprogress = (e) => {
                if (e.total > 0 && options.onProgress) {
                    options.onProgress({ percent: Math.round(e.loaded / e.total * 100) })
                }
            }

            xhr.onload = () => {
                if (xhr.status === 200) {
                    try {
                        const res = JSON.parse(xhr.responseText)
                        options.onSuccess(res, file)
                    } catch (e) {
                        options.onSuccess(xhr.responseText, file)
                    }
                } else {
                    options.onError(new Error('上传失败，状态码：' + xhr.status))
                }
            }

            xhr.onerror = () => options.onError(new Error('上传请求失败'))
            xhr.send(formData)
        },
         // 素材详情
        getCertDetail(){
             deletMaterial({id:this.$route.query.id},'get')
            .then(res =>{
               this.form = {
                name:res.data.name,
                classifyId:res.data.classifyId,
                }
            })
            .catch(err =>{})
        },
             // 文件上传成功
        handleSuccess(res, file){
           if(res.code == 0){
            this.uploadParms = res.data
           }
        },
            // 获取分类
        getLibClass(){
            this.itemList = []
             materialAllClassify({
                name:''
             })
            .then(res => {
              if(res.data){
               this.itemList = res.data
              }else{
                    this.itemList = []
             }

            })
            .catch(err => {
            })
        },
        // 保存
        openSub(formName){
         let params = {},
             method = "post"
         if(!this.$route.query.id) params = {...this.form,...this.uploadParms},method = "post";
         if(this.$route.query.id) params = {...this.form,...this.uploadParms,id:this.$route.query.id}, method = "put";
         if(!this.uploadParms.fileId) return this.$util.Notifi('请上传素材','error','fa-exclamation-circle');
          this.$refs[formName].validate((valid) => {  
                     if(valid){
                         //防抖提交
                    debounce(() => {
                        this.commentBness(params,method)
                    }, 500)
                     }
             })
        },
              commentBness(params,method){
               this.loading = true
                editMaterial(params,method)
                    .then(res => {
                        if(res.code == 0){
                        this.loading = false
                        if(!this.$route.query.id) this.$message.success('新增成功');
                            setTimeout(() => {
                        this.$router.push({
                        name:'materialLibrary',
                        query:{
                        }
                        })
                            }, 100);
                        }else{
                            this.loading = false
                        this.$message.error(res.msg)
                        }
                    })
                    .catch(err => {
                        this.loading = false
                    })
        },
    },
}
</script>
<style lang="scss" scoped>
#addMaterial{
    margin-bottom: 70px;
}
.importTopic{
    width: 100%;
    text-align: center;
    padding-top: 0px;
    box-sizing: border-box;
    .template-text{
        display: flex;
        align-items: center;
    justify-content: center;
    color: #7a8c99;
    font-size: 14px;
    cursor: pointer;
    padding-top: 20px;
.excel-icon{
        display: inline-block;
    width: 20px;
    height: 20px;
    background: url('../../../assets/images/excel-deactivate.svg') center no-repeat;
}
    }
    .tips-text{
   background-color: #f2f9fe;
    padding: 25px 10px 30px 30px;
    margin: 50px 35px 24px;
    text-align: left;
    .title{
        font-size: 18px;
        color: #36aafd;
    line-height: 30px;
    font-weight: normal;
    font-stretch: normal;
    }
    p{
        font-size: 16px;
        line-height: 30px;
    letter-spacing: 0px;
    color: #666666;
    }
    }
}
   .edit-from{
         margin-bottom: 44px;
         .public-tit{
            width: 100%;
            margin-bottom: 20px;
         }
         .edit-from-tit{
             background: rgb(215, 215, 215);
             padding: 10px 20px;
             font-size: 18px;
         }
           .el-form{
            flex-wrap: wrap;
            margin-top: 20px;
         .el-form-item{
            width: 50%;
        .el-input,.el-cascader{
            width: 80%;
        }
        .el-select,.el-input-group{
            width: 80%;
        }
        .el-textarea{
            width: 80%;
        }
        
        }
         }
         .App-tab{
            margin: 20px 0;
            
        }
         }
                    ::v-deep{
 .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
  }
  
  .avatar {
    width: 140px;
    height: 140px;
    display: block;
  }
   .avatar1 {
    width: 130px;
    height: 50px;
    display: block;
  }
  .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 200px;
        height: 200px;
        line-height: 200px;
        text-align: center;
    }
   .upload-icon {
        position: absolute;
        top: 50%;
        margin-left: -28px;
        margin-top: -18px;
    }
    .uploadPicture{
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 50px;
        background: rgba(0,0,0,.6);
        color: #fff;
        line-height: 50px;
        text-align: center;
    }
    .el-dialog{
        width: 50%;
    }
  }
  ::v-deep{
    .el-upload,.el-upload-dragger{
    background: none;
    border: none;
    height: auto;
   .icon-al-file-fill{
    font-size: 80px;
    color: #C0C4CC;
    margin: 0px 0 16px;
    }
    .el-button{
        margin-top: 30px;
    }
    }
    
 
}
</style>